





































































































































































































































































































































































































































































































import XLSX from 'xlsx';
import Loading from 'vue-loading-overlay';
import { Component, Mixins, Vue, Watch } from 'vue-property-decorator';
import Summary from '../../core/components/Summary.vue';
import Combobox from '../../core/components/Combobox.vue';
import AlertBox from '../../core/components/AlertBox.vue';
import SimpleMap from '../../core/components/SimpleMap.vue';
import ListEvents from '../../core/components/ListEvents.vue';
import PlusEyeButtons from '../../core/components/PlusEyeButtons.vue';
import SimpleTable from '../../core/components/SimpleTable.vue';
import ModalCheckboxList from '../../core/components/ModalCheckboxList.vue';
import DownloadingModal from '../../core/components/DownloadingModal.vue';
import ModalInsuranceHarvest from '../../insurance/components/ModalInsuranceHarvest.vue';
import RanchLinkButton from '../../insurance/components/RanchLinkButton.vue';
import ReseedingPeriodsSowing from '../../insurance/components/ReseedingPeriodsSowing.vue';
import ForcePeriodsSowing from '../../insurance/components/ForcePeriodsSowing.vue';
import DownloadWorkSegments from '../../insurance/components/DownloadWorkSegments.vue';
import AddResowingBtn from '../../insurance/components/AddResowingBtn.vue';
import CalcStatus from '../../insurance/components/CalcStatus.vue';
import SegmentsTable from '../../insurance/components/SegmentsTable.vue';
import LabelWithValue from '../../core/components/LabelWithValue.vue';
import Button from '../../core/components/Button.vue';
import Input from '../../core/components/Input.vue';
import ModalLinkRanchs from '../../insurance/components/ModalLinkRanchs.vue';
import ListWithItems from '../../core/components/ListWithItems.vue';
import MapReferences from '../../core/components/MapReferences.vue';
import DeleteConfirmation from '../../tracking/components/Geofences/DeleteConfirmation.vue';
import { CompanyStoreHelper, getVehicleData, NotificationStoreHelper, RootStoreHelper } from '../../core/mixins';
import {
    splitStringByIndex,
    EventBus,
    TypeEventBus,
    sortObjectByPropertyName,
    formatDate,
    goToUrl,
    getUniqueId,
    getRandomColor,
    getAlertColorByPriority,
    insuranceColors,
    segmentsColors,
    getCurrentTime,
    getCurrentTimestamp,
    getIndexFromList,
    isDict,
    PRIVILEGE_KEYS,
    KeyNames,
} from '../../core/utils/';
import { formatCommaSeparatedStringList, formattedDate, nullFormatterGetZero } from '../../core/utils/table-formatters';
import { NAME_ROUTES } from '../../core/utils/name-routes';
import {
    getCompanyItemById,
    getDateFromTimestamp,
    matchedIndexIdInArray,
    removeItemsFromList,
    parseFloatNumber
} from '../../core/utils';
import { Chart } from 'highcharts-vue';
import Highcharts, { error } from 'highcharts';
import exportingInit from 'highcharts/modules/exporting';
exportingInit(Highcharts);

import { InsuranceServices } from '../api/InsuranceServices';
import moment from 'moment';
import Axios from 'axios';
import { getRandom } from 'features/core/components/Map';
import { generateZipFile } from '../../norms';
import {
    getUrlVehicleConfiguration,
    getUrlFarmingDetail,
    getParsedBounds,
    getCalculationStatusTooltip,
    getCalculationStatusColor,
    alertHarvesRecalculation,
    openedByResowingMsg,
    getUrlRanchDetail,
    overlappedRanchMsg,
    getOverlapAlertText,
    sowingExportDepurationsOptions
} from '../utils';
import axios from 'axios';
import { dateTypes } from '../../core/models';
import { farmingTypeOptions } from '../helpers';
import { defaultNoDataValue, getValueAndUnit, getValueByType, unitsValuesChoices } from '../../../features/core/api';

// import jsonLayersData from '../layersDataRanch2349.json'

@Component({
    components: {
        highcharts: Chart,
        AlertBox,
        Summary,
        Combobox,
        SimpleTable,
        ModalInsuranceHarvest,
        Button,
        AddResowingBtn,
        Input,
        DeleteConfirmation,
        PlusEyeButtons,
        Loading,
        SimpleMap,
        ReseedingPeriodsSowing,
        ForcePeriodsSowing,
        ListEvents,
        ListWithItems,
        ModalCheckboxList,
        DownloadingModal,
        MapReferences,
        SegmentsTable,
        CalcStatus,
        DownloadWorkSegments,
        ModalLinkRanchs,
        RanchLinkButton,
        LabelWithValue
    }
})
export default class InsuranceSowingDetail extends Mixins(
    CompanyStoreHelper,
    NotificationStoreHelper,
    RootStoreHelper
) {
    hasParams: boolean = window.location.href.indexOf('?') !== -1 ? true : false;
    pageTitle: string = 'Detalle de Chacra de Siembra';
    forcedWorkSegments: Array<object> = [];
    //base data
    ranchName: any = '';
    ranchState: any = '-';
    securedArea: string = '';
    sowingArea: string = '-';
    resowingArea: string = '-';
    company: string = '';
    companyID: string = '';
    farmingName: string = '';
    farmingId: number = -1;
    sowingId: number = -1;
    startDate: string = '';
    harvestStartDate: string = '';
    endDate: string = '';
    polygonArea: string = '';
    humidity: string = '';
    daysWorked: string = '-';
    basePolygons: object = {};
    pendingDetail: boolean = true;
    hasChanges: boolean = false;
    hasChangesMsg: string = alertHarvesRecalculation;
    openedByResowingMessage: string = openedByResowingMsg;
    overlappedRanchMessage: string = overlappedRanchMsg;
    overlappedRanch: null | string = null;
    openedByResowing: boolean = false;
    loadingMap: boolean = true;
    showLayers: boolean = true;
    showReferences: boolean = true;
    loadingPatchRanch: boolean = false;
    pendingEvents: boolean = false;
    pendingSegment: boolean = false;
    forcingCalculate: boolean = false;
    recalculatingSowing: boolean = false;
    visibleModalExportDepuration: boolean = false;
    visibleDownloadingModal: boolean = false;
    pendingExportDepuration: boolean = false;
    defaultFileNameExportDepuration: string = '';
    defaultProgressRanchPolygon: string = '';
    listReferences: any = [];
    calculationStatus: null | object = null;
    classificationStatus: null | object = null;
    visibleModalLinkRanchs: boolean = false;
    selectedRanchToLink: object | null = null;
    linkRanchsText: string = 'Vínculo con Chacra de Cosecha';
    harvestRanchLink: object | null = null;
    collapsiblePanel: number | null = null;
    // responseLayers: any = jsonLayersData;
    optionsFinished: Array<object> = [
        {
            id: 1,
            value: 'Si',
            kei: true
        },
        {
            id: 2,
            value: 'No',
            kei: false
        }
    ];
    seedOptions: Array<object> = [];
    seedRv: boolean = false;
    seedSelected: any = null;
    notesList: Array<object> = [];
    scalePerformance: Array<number> = [];
    geojsonSegmentsOfWork: any = null;
    geojsonCalibrationPasses: any = null;
    geojsonTravel: any = null;
    vehiclesOptions: Array<object> = [];
    scaleHumidity: Array<number> = [];
    thereIsHarvestPolygon: boolean = false;
    ranchHasCsv: boolean = false;
    ranchIsCalculating: boolean = false;
    exportDepurationTitle: string = '';
    errorMsg: string = '';
    //tables
    itemsSegments: Array<object> = [];
    resowingPeriods: Array<object> = [];
    ranchId: string | null = null;
    exportDepurationOptions: object = {
        ranch_polygon: {
            title: 'Chacra',
            key: 'ranch_polygon',
            checked: false,
            disabled: false,
            icon: null
        },
        sown_polygon: {
            title: 'Polígono Avance Siembra',
            key: 'sown_polygon',
            disabled: false,
            checked: false,
            icon: null,
            disabledTooltip: 'No hay lineas de trabajo de siembra'
        },
        resowing: {
            title: 'Polígono avance Resiembra',
            key: 'resowing',
            disabled: false,
            checked: false,
            icon: null,
            disabledTooltip: 'No hay polígono de Avance de Resiembra'
        },
        smooth_resowing: {
            title: 'Polígono Resiembra',
            key: 'smooth_resowing',
            disabled: false,
            icon: null,
            disabledTooltip: 'No hay polígono de Resiembra'
        }
    };


    get isCarrier(): boolean {
        return this.$_getPrivileges[PRIVILEGE_KEYS.INSURANCE_CARRIER];
    }

    get modalLoadingDialogSowing(): HTMLFormElement {
        return this.$refs.downloadingModalSowing as HTMLFormElement;
    }
    get modalSegmentsTable(): HTMLFormElement {
        return this.$refs.segmentsTable as HTMLFormElement;
    }
    get reesedingPeriodsComponent(): HTMLFormElement {
        return this.$refs.reesedingPeriodsElement as HTMLFormElement;
    }

    visibilityModalLinkRanchs(value) {
        this.visibleModalLinkRanchs = value;
    }

    getRanchUrl(sowingRanchId){
        return getUrlRanchDetail(sowingRanchId)
    }

    removeLinkToRanch(){
        this.harvestRanchLink = null;
    }

    addNewLinkToRanch(newRanchLink, harvestRanchId){
        this.harvestRanchLink = null;
        setTimeout(() => {
                this.harvestRanchLink = newRanchLink;
        }, 0);
    }

    linkRanchs(){
        this.selectedRanchToLink = {
            id:this.ranchId,
            name: this.ranchName
        }
        this.visibilityModalLinkRanchs(true);
    }

    updateResowingPeriodsList(newPeriods){
        this.resowingPeriods = newPeriods;
        this.refreshLayersAfterAddOrRemoveResowing();
        
    }

    refreshLayersAfterAddOrRemoveResowing(){
        this.toggleSegmentsOfWork(false);
        this.showOnlyRanchLayer();
        this.mapSowingDetail.removeGeoJsonFeatures();
        this.modalSegmentsTable.clearSelectedWorkSegments();
        this.geojsonSegmentsOfWork = null;
        this.geojsonTravel = null;
        this.getRanchDetail();
    }

    updateSeedSelected(newName) {
        this.seedSelected = newName;
    }
    updateSeedRv(newName) {
        this.seedRv = newName;
    }

    disableExportRanchCsv() {
        this.updateExportDepurationItem('see_ranch_csv', 'disabled', true);
    }

    disableExportProgressRanch() {
        this.updateExportDepurationItem('see_ranch_progress', 'disabled', true);
    }
    defaultLayersItems: object = {
        ranch_polygon: {
            title: 'Chacra',
            key: 'ranch_polygon',
            checked: true,
            disabled: false,
            icon: 'mdi-square-outline'
        },
        smooth_resowing: {
            title: 'Polígono Resiembra',
            key: 'smooth_resowing',
            disabled: false,
            checked: false,
            icon: 'mdi-shape-polygon-plus',
            disabledTooltip: 'No hay polígono de Resiembra'
        },
        sown_polygon: {
            title: 'Polígono Avance Siembra',
            key: 'sown_polygon',
            disabled: false,
            checked: false,
            icon: 'mdi-shape-polygon-plus',
            disabledTooltip: 'No hay lineas de trabajo de siembra'
        },
        resowing: {
            title: 'Polígono avance Resiembra',
            key: 'resowing',
            disabled: false,
            checked: false,
            icon: 'mdi-shape-polygon-plus',
            disabledTooltip: 'No hay polígono de Avance de Resiembra'
        },
        machine_travel: {
            title: 'Recorrido máquinas',
            key: 'machine_travel',
            checked: false,
            disabled: !this.existMapLayers ? false : true,
            disabledTooltip: '',
            icon: 'mdi-tractor'
        },
        see_segments_of_work: {
            title: 'Clasificacion por segmentos de trabajo',
            key: 'see_segments_of_work',
            checked: false,
            disabled: false,
            disabledTooltip: 'No hay líneas de segmentos',
            icon: 'mdi-segment'
        }
    }
    layersItems: object = {...this.defaultLayersItems}
    mapLayers: object = {};
    cropTypes: Array<object> = [];

    //selectors
    stateSelected: any = null;
    stateRV: boolean = false;
    cropTypeSelected: any = null;
    grainTypeSelected: any = null;
    grainRV: boolean = false;
    cropTypeRv: boolean = false;
    finishedSelected: any = null;
    finishedRV: boolean = false;
    vehicleFilterSelected: any = null;
    filterVehicleRV: boolean = false;
    loadingMessageModal: string = '';
    ranchProgressPercent: number = -1;
    filteredSegmentsOfWork: Array<object> = [];
    chartOptions: object = {};
    visibleModalViewSegments: boolean = false;
    cancelTokenLoadSegment: any = null;
    segmentInfo: object | null = null;
    vehicleID: number = -1;
    clickedSegmentCompanyID: number = -1;
    responseData: object = {};
    ranchSowing: object = {};
    referencesCalibrations: any = null;
    calibrationsReferences: any = null;
    vehiclesReferences: any = null;
    workLinesReferences: any = null;
    enableRestoreButton: boolean = false;
    listOfPointsPerSegment: Array<object> = [];
    ranchBounds: object | null = null;
    performanceMapImage: string = '';
    performanceMapImageCSV: string = '';
    humidityMapImage: string = '';
    humidityMapCSVImage: string = '';
    resowingStartDate: string = '-';
    resowingEndDate: string = '-';
    resowingdaysWorked: string = '-';
    resowingDaysWorked: string = '-';
    selectedSegmentsOfWork: Array<object> = [];
    summaryData: Array<object> = []

    @Watch('$_getInsuranceProperties')
    observableProperties() {
        this.assignPropertiesData();
    }

    updateSelectedSegmentsInMap(elements) {
        this.selectedSegmentsOfWork = elements;
        this.mapSowingDetail.selectSegmentsOfWork(elements);
    }

    updateExportDepurationItem(kei, prop, value) {
        this.exportDepurationOptions[kei][prop] = value;
    }

    updateRanchName(newName) {
        this.ranchName = newName;
    }
    updateHasChanges(value) {
        this.hasChanges = value;
    }
    updateCalculationStatus(value) {
        this.calculationStatus = value
    }
    updateClassificationStatus(value) {
        this.classificationStatus = value
    }

    updateRanchProgressPercent(newName) {
        this.ranchProgressPercent = newName;
    }
    updateRanchState(newName) {
        this.ranchState = newName;
    }

    showRecalculatingInfo() {}

    getSegmentUrl(vehicleId: number, datetime_from: string, datetime_to: string) {
        let env_domain = process.env.VUE_APP_DOMAIN;
        let companyId = this.companyID;
        let url =
            env_domain +
            'travel/?c_id=' +
            companyId +
            '&v_id=' +
            vehicleId +
            '&date_start=' +
            datetime_from +
            '&date_end=' +
            datetime_to +
            '';
        return url;
    }

    clickAddNewResowingPeriod(){
        this.reesedingPeriodsComponent.clickAddNewResowingPeriod();
    }
    editSelectedPeriod(){
        this.reesedingPeriodsComponent.editSelectedPeriod(this.resowingPeriods[0]);
    }

    updateGeojsonSegmentsOfWork(segments, resowingSegments) {
        let self = this;
        let geoJson = {
            features: [],
            type: "FeatureCollection"
        }
        
        if (segments !== null && isDict(segments)) {
            let features = segments['features'];
            if(resowingSegments !== null){
                features = [
                    ...segments['features'],
                    ...resowingSegments['features']
                ]
            }

            features = features.map(function(item, index) {
                let customId = getUniqueId();
                let currentColor = segmentsColors[index] ? segmentsColors[index] : getRandomColor();
                item['properties']['name'] = '';
                item['properties']['strokeColor'] = currentColor;
                item['properties']['customId'] = customId;
                item['properties']['visible'] = false;
                item['properties']['veh_description'] = self.getVehicleData(item['properties']['vehicle']);
                item['properties']['veh_path'] = self.getSegmentUrl(
                    item['properties']['vehicle'],
                    item['properties']['start'],
                    item['properties']['end']
                );
                let indexInSegmentsTable = self.itemsSegments.findIndex(
                    segment =>
                        segment['start'] === item['properties']['start'] && 
                        segment['end'] === item['properties']['end']
                );
                if (indexInSegmentsTable !== -1) {
                    self.itemsSegments[indexInSegmentsTable]['customId'] = customId;
                    self.itemsSegments[indexInSegmentsTable]['color'] = currentColor;
                    // console.log("set segment color", {
                    //     segment: self.itemsSegments[indexInSegmentsTable],
                    //     color: currentColor
                    // })
                }
                return item;
            });
            geoJson['features'] = features;
        } else {
            this.updateLayerOption('see_segments_of_work', 'disabled', true);
        }
        this.geojsonTravel = geoJson;
        this.geojsonSegmentsOfWork = geoJson;
    }

    
    visibilityModalExportDepuration(value) {
        this.visibleModalExportDepuration = value;
    }
    visibilityDownloadingModal(value) {
        this.visibleDownloadingModal = value;
    }
    updateCompany(newName) {
        this.company = newName;
    }
    updateCompanyId(newName) {
        this.companyID = newName;
    }
    updateFarmingName(newName) {
        this.farmingName = newName;
    }
    updateFarmingId(id) {
        this.farmingId = id;
    }
    updateDaysWorked(value) {
        this.daysWorked = value;
    }
    updatePolygonArea(value) {
        this.polygonArea = value;
    }
    updateHarvestStartDate(value) {
        this.harvestStartDate = value;
    }
    updateHumidity(value) {
        this.humidity = value;
    }
    updatePendingDetail(value) {
        this.pendingDetail = value;
    }
    pendingMap(value) {
        this.loadingMap = value;
    }
    loadingComments(value) {
        this.pendingEvents = value;
    }
    updateVehicleFilterSelected(value) {
        this.vehicleFilterSelected = value;
    }
    updateVehicleFilterRV(newName) {
        this.filterVehicleRV = newName;
    }
    updateFinished(newName) {
        this.finishedSelected = newName;
    }
    updateOpenedByResowing(value) {
        this.openedByResowing = value;
    }
    updateCropTypeSelected(newName) {
        this.cropTypeSelected = newName;
    }
    updateCropTypeSelectedRV(newName) {
        this.cropTypeRv = newName;
    }
    updateFinishedRV(newName) {
        this.finishedRV = newName;
    }
    updateStateSelected(newName) {
        this.stateSelected = newName;
    }
    updateStateRV(newName) {
        this.stateRV = newName;
    }
    updateGrainType(newName) {
        this.grainTypeSelected = newName;
    }
    updateGrainTypeRV(newName) {
        this.grainRV = newName;
    }
    setMapLayers(value) {
        this.mapLayers = value;
    }
    setRanchNotes(value) {
        this.notesList = [];
        this.notesList = value;
    }
    setWorkSegments(list) {
        let self = this;
        list.forEach(segment => {
            let vehicleSegment = segment['vehicle'];
            let vehicleIndex = self.vehiclesOptions.findIndex(item => item['id'] == vehicleSegment);
            if (vehicleIndex !== -1) {
                self.vehiclesOptions[vehicleIndex]['has_segment'] = true;
                segment['vehicle'] = self.vehiclesOptions[vehicleIndex];
            }
            segment['customId'] = getUniqueId();
        });
        this.itemsSegments = list;
    }
    toggleShowLayers(value) {
        this.showLayers = !this.showLayers;
    }
    toggleReferences(value) {
        this.showReferences = !this.showReferences;
    }
    loadingModifyRanch(value) {
        this.loadingPatchRanch = value;
    }

    updateVehicleReferences(vehiclesList) {
        this.vehiclesReferences = null;
        this.vehiclesReferences = vehiclesList;
    }

    updateCalibrationsReferences(calibrationsReferences) {
        this.calibrationsReferences = null;
        this.calibrationsReferences = calibrationsReferences;
    }

    updateWorkLinesReferences(workLines) {
        this.workLinesReferences = null;
        this.workLinesReferences = workLines;
    }

    viewVehicleDetail(item) {
        if(!this.isCarrier){
            let url = getUrlVehicleConfiguration(item['vehicle']['id'], this.farmingId, farmingTypeOptions.sowing);
            goToUrl(url, true);
        }
    }

    mounted() {
        let self = this;
        this.assignPropertiesData();
        if (this.hasParams) {
            let urlParams = new URLSearchParams(window.location.search);
            this.ranchId = urlParams.get('id') !== null ? urlParams.get('id') : null;
        }
        this.$nextTick(() => {
            if (self.ranchId) {
                self.getRanchDetail();
                self.getRanchNotes(self.ranchId);
            }
        });
    }

    assignPropertiesData() {
        this.cropTypes = this.$_getInsuranceProperties['harvest_type'];
        this.seedOptions = this.$_getInsuranceProperties['seed_groups'];
    }

    dateFormatter(value) {
        return formattedDate(value);
    }

    parseNumber(value) {
        return parseFloatNumber(value);
    }

    addNewComment(newComment) {
        let data = {
            ranch: this.ranchId,
            text: newComment,
            public: this.isCarrier
        };
        this.loadingComments(true);
        InsuranceServices.postSowingRanchNote(data)
            .then(res => {
                this.notesList.push(res['ranch_note']);
                this.setRanchNotes(this.notesList);
                this.loadingComments(false);
            })
            .catch(err => {
                this.setRanchNotes([]);
                this.loadingComments(false);
            });
    }

    removeComment(idToRemove) {
        this.loadingComments(true);
        InsuranceServices.deleteSowingRanchNote(idToRemove)
            .then(res => {
                let indexNoteToRemove = matchedIndexIdInArray(this.notesList, idToRemove);
                if (indexNoteToRemove !== -1) {
                    this.notesList.splice(indexNoteToRemove, 1);
                }
                this.setRanchNotes(this.notesList);
                this.loadingComments(false);
            })
            .catch(err => {
                this.setRanchNotes([]);
                this.loadingComments(false);
            });
    }

    modifyComment(commentToModify: object) {
        this.loadingComments(true);
        let commentPublic =
            commentToModify && commentToModify['public'] !== undefined ? commentToModify['public'] : false;
        commentToModify['public'] = commentPublic;
        InsuranceServices.patchSowingRanchNote(commentToModify)
            .then(res => {
                let indexNoteToRemove = matchedIndexIdInArray(this.notesList, commentToModify['id']);
                if (indexNoteToRemove !== -1) {
                    this.$set(this.notesList[indexNoteToRemove], 'text', commentToModify['text']);
                }
                this.loadingComments(false);
                this.$_showAddPointOfInterest(res['data']['message']);
            })
            .catch(err => {
                this.setRanchNotes([]);
                this.loadingComments(false);
            });
    }

    getRanchNotes(ranchId) {
        this.loadingComments(true);

        InsuranceServices.getSowingRanchNotes(ranchId)
            .then(res => {
                this.setRanchNotes(res['ranch_notes']);
                this.loadingComments(false);
            })
            .catch(err => {
                this.setRanchNotes([]);
                this.loadingComments(false);
            });
    }

    modifyPolygonFromMap(feature: google.maps.Data.Feature){
        this.showOnlyRanchLayer();
        console.log("modifyPolygonFromMap sowing")
        feature.setProperty('harvest_type', this.cropTypeSelected !== null ? this.cropTypeSelected['id'] : '')
        feature.setProperty('name', this.ranchName)
        this.mapSowingDetail.modifyPolygon(feature);
        
    }

    saveRanchPolygon(ranchName: string, cropTypeSelected: object | null, coords, type){
        this.ranchName = ranchName;
        let cropTypeId = cropTypeSelected !== null ? cropTypeSelected['id'] : null;
        this.setRanchCropType(cropTypeId);
        this.modifyRanch(coords, type);
    }


    setForcedWorkSegments(items){
        let self = this;
        if(items.length > 0){
            items = items.map(function(item){
                let vehicleId = item.vehicle;
                let index = matchedIndexIdInArray(self.vehiclesOptions, vehicleId);
                console.log('vehicle id actual', item.vehicle);
                console.log("vehicles options", self.vehiclesOptions);
                return {
                    ...item,
                    vehicle: self.vehiclesOptions[index]
                }
            })
        }
        this.forcedWorkSegments = items;
    }

    getRanchDetail() {
        let self = this;
        if(self.ranchId){
            InsuranceServices.getSowingRanchDetail(self.ranchId)
                .then(async (res) => {
                    await self.getMapLayers(self.ranchId);
                    this.responseData = res;
                    this.setBaseData(res);
                    this.updatePendingDetail(false);
                    this.updateHasChanges(res['has_changes']);
                    this.setForcedWorkSegments(res['force_work_lapses']);
                    this.harvestRanchLink = res['harvest_ranch_link'];
                    this.overlappedRanch = getOverlapAlertText(formatCommaSeparatedStringList(res['sowing_ranch_data']['overlap'])) 
                })
                .catch(err => {
                    let msg = '';
                    if (err && err.response && err.response.data && err.response.data.message) {
                        msg = err.response.data.message;
                    } else {
                        msg = 'No se pudo obtener el detalle de la chacra: ' + this.ranchId;
                    }
                    this.$_showHistoricalError(msg);
                    this.updatePendingDetail(false);
                });
        }
    }


    getChartOptions(series) {
        return {
            tooltip: {
                formatter: function() {
                    return this.key;
                }
            },
            time: {
                useUTC: false
            },
            yAxis: [
                {
                    title: {
                        text: 'Rendimiento'
                    }
                },
                {
                    title: {
                        text: 'Humedad'
                    },
                    opposite: true
                }
            ],
            chart: {
                type: 'column',
                zoomType: 'x'
            },
            title: {
                text: ''
            },
            series: series
        };
    }

    selectPolylineInWorkSegments(feature: google.maps.Data.Feature) {
        //select a polyline clicked from map to work segments table
        let startDate = feature.getProperty('start');
        let endDate = feature.getProperty('end');
        //find polyline in work segments and select it;
        let indexPolylineInWorkSegments = this.itemsSegments.findIndex(
            segment => segment['start'] === startDate && segment['end'] === endDate
        );
        if (indexPolylineInWorkSegments !== -1) {
            this.modalSegmentsTable.addSegmentToSelectedOnes(this.itemsSegments[indexPolylineInWorkSegments]);
        }
    }

    selectedWorkSegment(clickedSegment) {
        this.layersItems['see_segments_of_work']['checked'] = true;
        this.toggleSegmentsOfWork(true);
    }

    getMapLayers(ranchId) {
        let self = this;
        this.updateVehicleReferences(null);
        this.updateWorkLinesReferences(null)
        this.layersItems = this.defaultLayersItems;
        this.pendingMap(true);
        InsuranceServices.getSowingRanchLayers(ranchId)
            .then(res => {
                this.setMapLayers(res);
                this.updateGeojsonSegmentsOfWork(res['segments'], res['resowing_segments']);
                setTimeout(() => {
                    self.setPolygons(res);
                    self.pendingMap(false);
                }, 1000);
                
            })
            .catch(err => {
                this.$_showHistoricalError('No se pudieron traer los datos de las capas');
                this.setMapLayers({});
                this.pendingMap(false);
                this.chartOptions = {};
            });
    }

    getFeatureWithCustomId(features, visible) {
        features[0]['properties']['name'] = this.ranchName;
        features[0]['properties']['customId'] = getUniqueId();
        features[0]['properties']['visible'] = visible;
        features[0]['properties']['strokeColor'] = 'black';
        features[0]['properties']['harvest_type'] = this.cropTypeSelected !== null ? this.cropTypeSelected['value'] : '';
        return features[0];
    }

    addRanchPolygon(res){
        let self = this;
        if (res && res['ranch_polygon']) {
            //chacra
            this.basePolygons = {
                ranch_polygon: self.getFeatureWithCustomId(res['ranch_polygon']['features'], true)
            } 
        }
    }

    addResowingPolygon(res){
         let self = this;
        if (res && res['resowing'] !== null) {
            //poligono de avance resiembra
            this.basePolygons = {
                ...this.basePolygons,
                resowing: self.getFeatureWithCustomId(res['resowing']['features'], true)
            }
        }else{
            this.updateLayerOption('resowing', 'disabled', true);
            this.exportDepurationOptions['resowing']['disabled'] = true;
            
        }
    }

    addSmoothResowingPolygon(res){
         let self = this;
        if (res && res['smooth_resowing'] !== null) {
            //poligono de resiembra
            this.basePolygons = {
                ...this.basePolygons,
                smooth_resowing: self.getFeatureWithCustomId(res['smooth_resowing']['features'], true)
            }
        }else{
            this.updateLayerOption('smooth_resowing', 'disabled', true);
            this.exportDepurationOptions['smooth_resowing']['disabled'] = true;
        }
    }
    addSownRanchPolygon(res){
         let self = this;
        if (res && res['sown_polygon'] !== null) {
            //poligono de avance siembra
            this.basePolygons = {
                ...this.basePolygons,
                sown_polygon: self.getFeatureWithCustomId(res['sown_polygon']['features'], true)
            }
            this.updateLayerOption('sown_polygon', 'checked', true);
        }else{
            this.updateLayerOption('sown_polygon', 'disabled', true);
            this.exportDepurationOptions['sown_polygon']['disabled'] = true;
        }
    }


    setPolygons(res) {
        let self = this;
        this.basePolygons = {}
        
        this.addRanchPolygon(res);
        this.addResowingPolygon(res);
        this.addSmoothResowingPolygon(res);
        this.addSownRanchPolygon(res);


        let geoJsonWithAllPolygons = {
            type: 'FeatureCollection',
            features: Object.values(this.basePolygons)
        };


        self.mapSowingDetail.addGeoJson(geoJsonWithAllPolygons);

        self.showOnlyRanchLayer();
    }

    showOnlyRanchLayer() {
        let self = this;
        setTimeout(() => {
            self.toggleRanch(true);
            self.toggleResowingPolygon(false);
            self.toggleSmoothResowingPolygon(false);
            self.toggleSownPolygon(false);
        }, 0);
    }

    updateResowingPeriods(resowing){
        if(resowing !== null){
            this.resowingPeriods = [{
                id: resowing['id'],
                start_date: resowing['start_date'],
                end_date: resowing['end_date']
            }]
            this.resowingDaysWorked = resowing['days_worked'];
            this.resowingStartDate = formatDate(resowing['start_date']);
            this.resowingEndDate = formatDate(resowing['end_date']);
        }
    }

    setSowingRanchData(sowingRanchData){
        if (sowingRanchData) {
            if (sowingRanchData['start_date']) {
                this.startDate = formatDate(sowingRanchData['start_date']);
            }
            if (sowingRanchData['end_date']) {
                this.endDate = formatDate(sowingRanchData['end_date']);
            }
            this.updateRanchName(sowingRanchData['name']);
            this.updatePolygonArea(sowingRanchData['area']);
            this.updateDaysWorked(sowingRanchData['days_worked']);
            this.updateRanchFinished(sowingRanchData['finished'])
            this.sowingArea = sowingRanchData['sown_area'];
            this.resowingArea = sowingRanchData['resown_area'];
            this.updateOpenedByResowing(sowingRanchData['open_by_resowing'])

            setTimeout(() => {
                this.setRanchCropTypeByName(sowingRanchData['harvest_type']);
                this.setRanchSeedGroup(sowingRanchData['seed_group']);
            }, 500);
        }
    }

    setRanchSeedGroup(seedGroup: number | null) {
        this.updateSeedSelected(null);
        if (seedGroup !== null && this.seedOptions) {
            let indexInSeedList = this.seedOptions.findIndex(item => Number(item['id']) === seedGroup);
            if (indexInSeedList !== -1) {
                this.updateSeedSelected(this.seedOptions[indexInSeedList]);
            }
        }
    }

    setFarmingData(farmingData){
        this.updateFarmingName(farmingData['name']);
        this.updateFarmingId(farmingData['id']);
        this.updateCompany(farmingData['company']['name']);
        this.updateCompanyId(farmingData['company']['id']);
    }

    setBaseData(res) {
        this.setWorkSegments([]);
        this.setFarmingData(res['farming'])
        this.updateResowingPeriods(res['resowing']);
        this.sowingId = res['sowing']['id'];
        this.setVehicles(res['vehicles']);
        this.updateCalculationStatus(res['sowing']['calculation_status']);
        this.updateClassificationStatus(res['sowing']['classification_status']);
        this.setSowingRanchData(res['sowing_ranch_data'])
        this.setWorkSegments(res['segments']);
        this.updateSummaryFields();
    }

    updateSummaryFields(){
        let self = this;
        let summaryData = [
           {
             text: 'Nombre:',
             value: self.ranchName,
             info: ''
           },
           {
             text: 'Área Polígono:',
             value: getValueAndUnit(self.polygonArea, unitsValuesChoices.area),
             info: ''
           }
        ];


        if(self.cropTypeSelected !== null){
            summaryData.push({
                text: `${KeyNames.crop_type}:`,
                value: self.cropTypeSelected['value'],
                info: ''
            })
        }
       
        if(self.startDate !== defaultNoDataValue){
            summaryData.push({
                text: `${KeyNames.start_date}:`,
                value: getValueByType(self.startDate),
                info: ''
            })
        }
        if(self.endDate !== defaultNoDataValue){
            summaryData.push({
                text: `${KeyNames.end_date}:`,
                value: getValueByType(self.endDate),
                info: ''
            })
        }
        
        this.summaryData = summaryData;
    }


    setRanchSowing(harvest) {
        this.ranchSowing = harvest;
    }

    setVehicles(vehicles) {
        let self = this;
        this.vehiclesOptions = vehicles.map(function(item, index) {
            return {
                id: item['id'],
                vin: item['vin'],
                description: item['description'],
                vehicleData: item['description'],
                color: self.getReferenceColorByIndex(index),
                has_segment: false
            };
        });
    }

    clickBtnExportDepuration() {
        this.exportDepurationTitle = 'Exportar depuración';
        if (this.ranchName !== '') {
            this.exportDepurationTitle += ' Chacra: <b>' + this.getUpdatedRanchName() + '</b>';
            this.defaultFileNameExportDepuration =
                'depuración_chacra_' + this.getUpdatedRanchName() + '_' + getCurrentTimestamp(dateTypes.globalFilterDateFormat);
        }
        this.visibilityModalExportDepuration(true);
    }

    showLoadingModal(msg) {
        this.$_showLoadingDialog(msg)
    }

    showSuccessLoadingModal(msg) {
        this.$_successLoadingDialog({
            response: {},
            alternative_msg: msg
        });
    }
    showCatchLoadingModal(err, alternativeMsg) {
        this.$_catchLoadingDialog({
            response: err,
            alternative_msg: alternativeMsg
        });
    }

    getUpdatedRanchName() {
        let name = this.ranchName;
        if (name.indexOf('.') !== -1) {
            name = name.replace(/\./g, '_');
        }
        console.log('name', name);
        return name;
    }

    async exportDepurationAction(folderName: string, optionsToExport: Array<string>) {
        this.pendingExportDepuration = true;
        let dataToExport: any = {};

        for (let i = 0; i < optionsToExport.length; i++) {
            let option = optionsToExport[i];
            this.showLoadingModal('Generando archivo...');
            let updatedRanchName = this.getUpdatedRanchName();
            let resownArea = this.resowingArea; 
            switch (option) {
                case 'ranch_polygon':
                    //Adjunto el archivo para el polígono de la chacra
                    let nameRanchFile = 'poligono_chacra_' + updatedRanchName + '.geojson';
                    this.basePolygons['ranch_polygon']['properties']['name'] = updatedRanchName;
                    let ranchData = JSON.stringify({
                        type: 'FeatureCollection',
                        features: [this.removeExtraKeysFromPolygon(this.basePolygons['ranch_polygon'])]
                    });
                    dataToExport[nameRanchFile] = ranchData;
                    break;
                case 'resowing':
                    //Adjunto el archivo para el polígono de Avance Resiembra
                    let resowingRanchPolygonFile = 'poligono_avance_resiembra_chacra_' + updatedRanchName + '.geojson';
                    this.basePolygons['resowing']['properties']['name'] = updatedRanchName;
                    this.basePolygons['resowing']['properties']['area'] = resownArea;
                    let resowingPolyConfig = JSON.stringify({
                        type: 'FeatureCollection',
                        features: [this.removeExtraKeysFromPolygon(this.basePolygons['resowing'])]
                    });
                    dataToExport[resowingRanchPolygonFile] = resowingPolyConfig;
                    break;
                case 'sown_polygon':
                    //Adjunto el archivo para el polígono de Avance Siembra
                    let sownRanchPolygonFile = 'poligono_avance_siembra_chacra_' + updatedRanchName + '.geojson';
                    this.basePolygons['sown_polygon']['properties']['name'] = updatedRanchName;
                    let ranchConfig = JSON.stringify({
                        type: 'FeatureCollection',
                        features: [this.removeExtraKeysFromPolygon(this.basePolygons['sown_polygon'])]
                    });
                    dataToExport[sownRanchPolygonFile] = ranchConfig;
                    break;
                case 'smooth_resowing':
                    //Adjunto el archivo para el polígono de Resiembra
                    let smoothRanchPolygonFile = 'poligono_resiembra_chacra_' + updatedRanchName + '.geojson';
                    this.basePolygons['smooth_resowing']['properties']['name'] = updatedRanchName;
                    this.basePolygons['smooth_resowing']['properties']['area'] = resownArea;
                    let ranchSetting = JSON.stringify({
                        type: 'FeatureCollection',
                        features: [this.removeExtraKeysFromPolygon(this.basePolygons['smooth_resowing'])]
                    });
                    dataToExport[smoothRanchPolygonFile] = ranchSetting;
                    break;
            }
        }

        this.showLoadingModal('Descargando archivo...');

        this.pendingExportDepuration = false;
        generateZipFile(folderName, dataToExport, false);
        this.showSuccessLoadingModal('Archivo descargado con éxito');
    }

    removeExtraKeysFromPolygon(polygonObject: object) {
        //removes the keys 'customId' && 'visible'
        if(polygonObject['properties'].hasOwnProperty('customId')){
            delete polygonObject['properties']['customId']
        }
        if(polygonObject['properties'].hasOwnProperty('visible')){
            delete polygonObject['properties']['visible']
        }
        return {
            ...polygonObject,
            properties: polygonObject['properties']
        };
    }

    async downloadImageFromUrl(url) {
        try {
            let base64 = await InsuranceServices.downloadImageFromUrl(url);
            return base64;
        } catch (error) {
            return null;
        }
    }

    updateRanchFinished(value) {
        let option = value ? this.optionsFinished[0] : this.optionsFinished[1];
        this.updateFinished(option);
    }

    setRanchCropTypeByName(harvestTypeName: string) {
        let cropType = -1;
        if (this.cropTypes) {
            let indexInCropTypes = getIndexFromList(this.cropTypes, 'value', harvestTypeName);
            if (indexInCropTypes !== -1) {
                this.updateCropTypeSelected(this.cropTypes[indexInCropTypes]);
            }
        }
    }

    setRanchCropType(harvestTypeId: string | null) {
        let cropType = harvestTypeId == null ? -1 : harvestTypeId;
        if (this.cropTypes) {
            let indexInCropTypes =  getIndexFromList(this.cropTypes, 'id', Number(cropType));
            if (indexInCropTypes !== -1) {
                this.updateCropTypeSelected(this.cropTypes[indexInCropTypes]);
            }
        }
    }

    backToAnlyticView() {
        this.$router.push(NAME_ROUTES.INSURANCE_FARMING_ANALYTIC_SOWING.path);
    }

    get getAlertColor() {
        return getAlertColorByPriority();
    }

    get existSegmentsOfWork() {
        return this.itemsSegments.length !== 0 ? true : false;
    }

    get getActiveVehicles() {
        return 'vehiculo uno';
    }

    get getActiveScale() {
        return [];
    }

    get getActiveScaleType() {
        return '';
    }

    get mapSowingDetail(): HTMLFormElement {
        return this.$refs.mapSowingDetail as HTMLFormElement;
    }

    get existMapLayers() {
        return this.mapLayers == null ? false : true;
    }

    viewFarming() {
        if (this.farmingId !== -1) {
            let url = getUrlFarmingDetail(this.farmingId);
            goToUrl(url, true);
        }
    }

    itemChanged(item) {
        console.log('item changed', item);
        switch (item['key']) {
            case 'machine_travel':
                //Ver recorrido de máquinas
                this.toggleTravel(item['checked']);
                break;
            case 'ranch_polygon':
                //Chacra
                 this.toggleRanch(item['checked']);
                break;
            case 'resowing':
                //Polígono de avance Resiembra
                this.toggleResowingPolygon(item['checked']);
                break;
            case 'smooth_resowing':
                //Polígono Resiembra
                this.toggleSmoothResowingPolygon(item['checked']);
                break;
            case 'sown_polygon':
                //Lineas de Trabajo (Siembra)
                this.toggleSownPolygon(item['checked']);
                break;
            case 'see_segments_of_work':
                //Segmentos de trabajo
                this.toggleSegmentsOfWork(item['checked']);
                break;
        }
    }

    toggleRanch(visible) {
        //Chacra
        if(visible){
            this.updateLayerOption('ranch_polygon', 'checked', true);
            this.mapSowingDetail.showFeatureInMap(this.basePolygons['ranch_polygon']);
        }else{
            this.updateLayerOption('ranch_polygon', 'checked', false);
            this.mapSowingDetail.hideFeatureInMap(this.basePolygons['ranch_polygon']);
        }
    }

    toggleSmoothResowingPolygon(visible){
        //Polígono de siembra
        if(visible){
            this.updateLayerOption('smooth_resowing', 'checked', true);
            this.mapSowingDetail.showFeatureInMap(this.basePolygons['smooth_resowing']);
        }else{
            this.updateLayerOption('smooth_resowing', 'checked', false);
            this.mapSowingDetail.hideFeatureInMap(this.basePolygons['smooth_resowing']);
        }
    }
    toggleSownPolygon(visible){
        //Polígono de siembra
        if(visible){
            this.updateLayerOption('sown_polygon', 'checked', true);
            this.mapSowingDetail.showFeatureInMap(this.basePolygons['sown_polygon']);
        }else{
            this.updateLayerOption('sown_polygon', 'checked', false);
            this.mapSowingDetail.hideFeatureInMap(this.basePolygons['sown_polygon']);
        }

    }
    toggleResowingPolygon(visible){
        //Polígono de Resiembra
        if(visible){
            this.updateLayerOption('resowing', 'checked', true);
            this.mapSowingDetail.showFeatureInMap(this.basePolygons['resowing']);
        }else{
            this.updateLayerOption('resowing', 'checked', false);
            this.mapSowingDetail.hideFeatureInMap(this.basePolygons['resowing']);
        }
    }

    getVehicleData(vehicleId: number) {
        let data = '';
        let index = matchedIndexIdInArray(this.vehiclesOptions, vehicleId);
        if (index > -1) {
            let vehicle = this.vehiclesOptions[index];
            data = vehicle['vin'] + ' - ' + vehicle['description'];
        }
        return data;
    }

    toggleTravel(visible) {
        //Recorrido de máquinas
        let _this = this;

        if (visible) {
            this.toggleSegmentsOfWork(false);
            this.updateLayerOption('see_segments_of_work', 'checked', false);
            this.updateVehicleReferences(this.vehiclesOptions);
            this.mapSowingDetail.showTravel(JSON.parse(JSON.stringify(this.geojsonTravel)), this.vehiclesOptions);
        } else {
            this.updateVehicleReferences(null);
            this.mapSowingDetail.hideTravel();
        }
    }

    getReferenceColorByIndex(index) {
        return insuranceColors[index] ? insuranceColors[index] : getRandomColor();
    }

    toggleSegmentsOfWork(visible) {
        //Clasificación por fecha/maquina de trabajo
        //new way of visualization based on linestrings
        if (visible) {
            this.toggleTravel(false);
            this.updateLayerOption('machine_travel', 'checked', false);
            this.mapSowingDetail.showSegmentsOfWork(this.geojsonSegmentsOfWork);
            this.updateWorkLinesReferences(this.itemsSegments);
        } else {
            this.mapSowingDetail.hideSegmentsOfWork();
            this.updateLayerOption('see_segments_of_work', 'checked', false);
            this.updateWorkLinesReferences(null);
        }
    }

    updateLayerOption(kei, prop, value) {
        this.layersItems[kei][prop] = value;
    }

    forceCalculateNow() {
        if (this.sowingId !== -1) {
            this.forcingCalculate = true;
            InsuranceServices.sowingForceRecalculate(this.sowingId)
                .then(response => {
                    this.forcingCalculate = false;
                    let msg = '';
                    if (response && response.message) {
                        msg = response.message;
                    } else {
                        msg = 'La siembra se está recalculando';
                    }
                    this.$_showAddPointOfInterest(msg);
                    // self.successLoadingDialog(msg);
                })
                .catch(error => {
                    this.forcingCalculate = false;
                    this.$_showAddPointOfInterest('No se pudo recalcular la siembra');
                });
        }
    }
    forceRecalculateSowing() {
        if (this.sowingId !== -1) {
            this.recalculatingSowing = true;
            InsuranceServices.sowingRecalculate(this.sowingId)
                .then(response => {
                    this.recalculatingSowing = false;
                    let msg = '';
                    if (response && response.message) {
                        msg = response.message;
                    } else {
                        msg = 'Siembra recalculada con éxito';
                    }
                    this.$_showAddPointOfInterest(msg);
                    // self.successLoadingDialog(msg);
                })
                .catch(error => {
                    this.recalculatingSowing = false;
                    this.$_showAddPointOfInterest('No se pudo recalcular la siembra');
                    // self.showCatchLoadingDialog(error);
                });
        }
    }

    updateCoordsInRanchPolygon(updatedRanch){
        if(updatedRanch['ranch_polygon']){
            if(this.mapSowingDetail && typeof this.mapSowingDetail.removeGeoJsonFeatures === 'function'){
                this.mapSowingDetail.removeGeoJsonFeatures()
            }
            this.getMapLayers(this.ranchId);
        }
    }

    modifyRanch(coords, type) {
        let hasCoords = coords.length > 0 ? true : false;
        if(hasCoords){
            this.pendingMap(true);
        }
        let self = this;
        let isFinished = this.finishedSelected !== null ? this.finishedSelected['kei'] : null;
        let seedWasSelected = this.seedSelected !== null ? this.seedSelected['id'] : null;
        let data = {
            name: this.ranchName,
            harvest_type: this.cropTypeSelected == null ? null : this.cropTypeSelected['id'],
            ...(isFinished !== null ? { finished: isFinished } : {}),
            seed_group: seedWasSelected !== null ? Number(this.seedSelected['id']) : null,
            ...(hasCoords ? { [type]: coords } : {}),
        };
        this.toggleRanch(false);
        this.loadingModifyRanch(true);
        InsuranceServices.patchSowingRanch(data, Number(self.ranchId))
            .then(res => {
                console.log("chacra de siembra modificada");
                this.$_successLoadingDialog({
                    response: res,
                    alternative_msg: 'Chacra modificada con exito'
                });
                this.updateCoordsInRanchPolygon(res['data']['new_sowing_ranch']);
                this.loadingModifyRanch(false);
                
            })
            .catch(error => {
                this.$_catchLoadingDialog({
                    response: error.response.data || {},
                    alternative_msg: 'No se pudo modificar la chacra'
                });
                this.loadingModifyRanch(false);
            });
    }

    setErrorForm(text) {
        this.errorMsg = text;
    }

    get formIsValid() {
        this.setErrorForm('')
        if (this.ranchName === '') {
            this.setErrorForm('No ingreso el nombre de la chacra')
            return false;
        }
        if (this.finishedSelected === null) {
            this.setErrorForm('No especifico si esta cerrada')
            return false;
        }
        return true;
    }
}
